import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, DollarSignIcon, SparklesIcon } from 'lucide-react';
export function HowToBook() {
  const steps = [{
    icon: <MessageCircleIcon className="w-6 h-6 text-near-black" data-id="element-184" />,
    title: 'Step 1',
    desc: 'DM or call to check availability'
  }, {
    icon: <DollarSignIcon className="w-6 h-6 text-near-black" data-id="element-185" />,
    title: 'Step 2',
    desc: 'Pay $25 non-refundable deposit'
  }, {
    icon: <SparklesIcon className="w-6 h-6 text-near-black" data-id="element-186" />,
    title: 'Step 3',
    desc: 'Show up, relax, leave looking incredible'
  }];
  return <section id="book" className="py-24 bg-ivory" data-id="element-187">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
        <div className="text-center mb-16" data-id="element-189">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display italic text-4xl md:text-5xl lg:text-6xl text-near-black mb-6" data-id="element-190">
            Ready to get braided?
          </motion.h2>
          <div className="w-16 h-px bg-terracotta mx-auto" data-id="element-191"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative mb-16" data-id="element-192">
          <div className="hidden md:block absolute top-10 left-[16%] right-[16%] h-px bg-brand-gold/30 border-dashed border-t-2" data-id="element-193"></div>
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center z-10" data-id="element-194">
              <div className="w-20 h-20 bg-brand-gold rounded-full flex items-center justify-center mb-6 shadow-lg shadow-brand-gold/20" data-id="element-195">
                {step.icon}
              </div>
              <h3 className="font-display text-2xl font-bold text-near-black mb-3" data-id="element-196">
                {step.title}
              </h3>
              <p className="font-body text-near-black/70 max-w-xs" data-id="element-197">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}